// import styles
import '../scss/main.scss';

// application imports
import "core-js/stable";
import "regenerator-runtime/runtime";
import $ from 'jquery';
import {App} from './app.ts';

// load ie polyfills
import 'url-polyfill';

// initialize the app
$(function () {
    'use strict';
    console.debug('main: initializing Donaupark Camping App ...');

    try {
        new App().init().then(() =>
            console.debug('main: Donaupark Camping App successfully initialized'));

    } catch (err) {
        console.error("main: Donaupark Camping App failed to initialize", err);
    }
});
